var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactPrivacyCyanV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 8,
    r: 3.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 20c0-3.5 2.5-6 5.5-6s5.5 2.5 5.5 6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8h4M19 6v4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactPrivacyCyanV2);
export default __webpack_public_path__ + "static/media/contact-privacy-cyan-v2.524dc44e3a757c6e1dc5dac7ee77ae61.svg";
export { ForwardRef as ReactComponent };